export { default, getStaticProps } from 'containers/CookiesPage/CookiesPage';
